import { render, staticRenderFns } from "./BasePopover.vue?vue&type=template&id=6dcdfb32&scoped=true&"
import script from "./BasePopover.vue?vue&type=script&lang=js&"
export * from "./BasePopover.vue?vue&type=script&lang=js&"
import style0 from "./BasePopover.vue?vue&type=style&index=0&id=6dcdfb32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcdfb32",
  null
  
)

export default component.exports